import React from 'react';
import { Pangolin } from 'services/accounts/types';
import { Link } from 'ui/base/link';
import { BasePath } from 'services/base/page_path';
import { Theme, ThemedStyles, useStyles } from 'ui/base/theme';
import { getBandwidthUnitText } from 'ui/standard/input/bandwidth_input/bandwidth_input';
import baseStyles from './bandwidth_box.module.css';
import Messages from './bandwidth_box_messages';
import UploadIcon from './assets/network/upload.png';
import DownloadIcon from './assets/network/download.png';

type BandwidthBoxStyles = {
  link: string;
  container: string;
  row: string;
  labelRow: string;
  secondRow: string;
  column: string;
  icon: string;
  label: string;
  value: string;
  unit: string;
  caretContainer: string;
  caretIcon: string;
};

const themedStyles: ThemedStyles<BandwidthBoxStyles> = {
  [Theme.DAYLIGHT]: {
    link: baseStyles.daylightLink,
    container: baseStyles.daylightContainer,
    row: baseStyles.row,
    labelRow: baseStyles.labelRow,
    secondRow: baseStyles.secondRow,
    column: baseStyles.column,
    icon: baseStyles.icon,
    label: baseStyles.daylightLabel,
    value: baseStyles.daylightValue,
    unit: baseStyles.daylightUnit,
    caretContainer: baseStyles.daylightCaretContainer,
    caretIcon: baseStyles.daylightCaretIcon,
  },
  [Theme.MIDNIGHT]: {
    link: baseStyles.midnightLink,
    container: baseStyles.midnightContainer,
    row: baseStyles.row,
    labelRow: baseStyles.labelRow,
    secondRow: baseStyles.secondRow,
    column: baseStyles.column,
    icon: baseStyles.icon,
    label: baseStyles.midnightLabel,
    value: baseStyles.midnightValue,
    unit: baseStyles.midnightUnit,
    caretContainer: baseStyles.midnightCaretContainer,
    caretIcon: baseStyles.midnightCaretIcon,
  },
};

type BandwidthBoxProps = {
  pangolin: Pangolin;
};
export const BandwidthBox = ({ pangolin }: BandwidthBoxProps) => {
  const styles = useStyles(themedStyles);
  return (
    <Link path={{ kind: BasePath.BANDWIDTH_SETTINGS, pangolinID: pangolin.id }} className={styles.link}>
      <div className={styles.container}>
        <div className={styles.row}>
          <div className={styles.column}>
            <div className={styles.labelRow}>
              <img src={DownloadIcon} className={styles.icon} alt='download' />
              <div className={styles.label}>
                {Messages.download()}
              </div>
            </div>
            <div className={styles.secondRow}>
              <div className={styles.value}>
                {pangolin.bandwidthDownloadString}
              </div>
              <div className={styles.unit}>
                {getBandwidthUnitText(pangolin.bandwidthDownloadUnits)}
              </div>
            </div>
          </div>
          <div className={styles.column}>
            <div className={styles.labelRow}>
              <img src={UploadIcon} className={styles.icon} alt='upload' />
              <div className={styles.label}>
                {Messages.upload()}
              </div>
            </div>
            <div className={styles.secondRow}>
              <div className={styles.value}>
                {pangolin.bandwidthUploadString}
              </div>
              <div className={styles.unit}>
                {getBandwidthUnitText(pangolin.bandwidthUploadUnits)}
              </div>
            </div>
          </div>
          <div className={styles.caretContainer}>
            <div className={styles.caretIcon}/>
          </div>
        </div>
      </div>
    </Link>
  );
};
